import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export const voteInPoll = createAction(`${actionTypePrefix}.POLL_VOTE`, (payload)=>payload);
export const voteInPollFail = createAction(`${actionTypePrefix}.POLL_VOTE_FAIL`, (payload)=>payload);
export const voteInPollSuccess = createAction(`${actionTypePrefix}.POLL_VOTE_SUCCESS`, (payload)=>payload);

//# sourceMappingURL=actionCreators.js.map